import React, { useState, useEffect } from "react";
import { Vacantes as VacantesApi } from "../../../../../api";

const vacantesApi = new VacantesApi();

const REDES = [
  { key: "linkedin",  label: "LinkedIn",    placeholder: "https://linkedin.com/in/tu-perfil" },
  { key: "github",    label: "GitHub",      placeholder: "https://github.com/tu-usuario" },
  { key: "facebook",  label: "Facebook",    placeholder: "https://facebook.com/tu-perfil" },
  { key: "instagram", label: "Instagram",   placeholder: "https://instagram.com/tu-usuario" },
  { key: "twitter",   label: "X / Twitter", placeholder: "https://twitter.com/tu-usuario" },
  { key: "tiktok",    label: "TikTok",      placeholder: "https://tiktok.com/@tu-usuario" },
];

const AREAS_FALLBACK = [
  "Finanzas", "Cuentas por Cobrar", "Gestión Humana",
  "Ejecución / Mercaderistas", "Ventas (Ejecutivo / Supervisor)",
  "Logística", "Almacén", "Tecnología de Información",
  "Comercial (Gerente)", "Mensajería", "Conserjería", "Seguridad / Mecánico",
];

export function AreaInteresForm({ values, setValues }) {
  const [vacantes, setVacantes] = useState([]);
  const [loadingVacantes, setLoadingVacantes] = useState(true);
  const [areaInteres, setAreaInteres] = useState(values.area_interes || "");
  const [validArea, setValidArea] = useState("");
  const [redesSeleccionadas, setRedesSeleccionadas] = useState({});
  const [redesUrls, setRedesUrls] = useState({
    linkedin: "", github: "", facebook: "", instagram: "", twitter: "", tiktok: "",
  });

  useEffect(() => {
    vacantesApi.getAll(true)
      .then((data) => { if (data?.length) setVacantes(data); })
      .catch(() => {})
      .finally(() => setLoadingVacantes(false));
  }, []);

  const toggleRed = (key) => {
    setRedesSeleccionadas((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) setRedesUrls((u) => ({ ...u, [key]: "" }));
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!areaInteres) {
      setValidArea("Debe seleccionar un área de interés");
      return;
    }
    const redesFinal = {};
    REDES.forEach(({ key }) => {
      redesFinal[key] = redesSeleccionadas[key] ? redesUrls[key] : "";
    });
    setValues({ ...values, area_interes: areaInteres, ...redesFinal, step: values.step + 1 });
  };

  const handleBack = () => setValues({ ...values, step: values.step - 1 });

  return (
    <form className="w-full max-w-2xl mx-auto my-6 flex flex-col gap-6" onSubmit={handleSubmit}>
      <div>
        <h2 className="text-2xl font-extrabold text-[#151C84] mb-1">Área de Interés</h2>
        <p className="text-sm text-gray-500">Selecciona el puesto o área al que deseas aplicar.</p>
      </div>

      {/* Área de interés — select dinámico */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Puesto / Área de Interés <span className="text-[#C81416]">*</span>
        </label>
        {loadingVacantes ? (
          <div className="h-10 bg-gray-100 rounded-lg animate-pulse" />
        ) : (
          <select
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#151C84]/30 bg-white"
            value={areaInteres}
            onChange={(e) => { setAreaInteres(e.target.value); setValidArea(""); }}
          >
            <option value="">— Selecciona un área —</option>
            {vacantes.length > 0 ? (
              <>
                <optgroup label="Vacantes activas">
                  {vacantes.map((v) => (
                    <option key={v.id} value={v.titulo}>
                      {v.titulo}{v.departamento ? ` — ${v.departamento}` : ""}
                    </option>
                  ))}
                </optgroup>
                <optgroup label="Otras áreas">
                  {AREAS_FALLBACK.map((a) => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                </optgroup>
              </>
            ) : (
              AREAS_FALLBACK.map((a) => (
                <option key={a} value={a}>{a}</option>
              ))
            )}
          </select>
        )}
        {validArea && <p className="mt-1.5 text-xs text-[#C81416] font-medium">{validArea}</p>}
      </div>

      {/* Redes Sociales — checkboxes primero, luego inputs */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-1">
          Redes Sociales <span className="text-gray-400 font-normal">(opcional)</span>
        </h3>
        <p className="text-xs text-gray-400 mb-4">
          Marca las redes que tengas y proporciona el enlace. La IA las usará para complementar tu perfil.
        </p>

        {/* Pill toggles para seleccionar redes */}
        <div className="flex flex-wrap gap-2 mb-4">
          {REDES.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              onClick={() => toggleRed(key)}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all duration-200 ${
                redesSeleccionadas[key]
                  ? "bg-[#151C84] text-white border-[#151C84]"
                  : "bg-gray-50 text-gray-600 border-gray-200 hover:border-[#151C84]/40"
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Inputs solo para las redes seleccionadas */}
        {REDES.some(({ key }) => redesSeleccionadas[key]) ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {REDES.filter(({ key }) => redesSeleccionadas[key]).map(({ key, label, placeholder }) => (
              <div key={key}>
                <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
                <input
                  type="url"
                  value={redesUrls[key]}
                  onChange={(e) => setRedesUrls({ ...redesUrls, [key]: e.target.value })}
                  placeholder={placeholder}
                  className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#151C84]/30"
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-400 italic">Ninguna seleccionada — puedes dejar esto en blanco.</p>
        )}
      </div>

      {/* Botones */}
      <div className="flex gap-3">
        <button
          type="button"
          onClick={handleBack}
          className="flex-1 py-3 rounded-xl border border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition-colors"
        >
          Regresar
        </button>
        <button
          type="submit"
          className="flex-1 py-3 rounded-xl bg-[#151C84] text-white font-semibold text-sm hover:bg-[#0d125c] transition-colors shadow-[0_4px_14px_rgba(21,28,132,0.3)]"
        >
          Siguiente
        </button>
      </div>
    </form>
  );
}
